import strings from '@/i18n/index';

export function fancyTimeFormat(duration: number) {
  // Hours, minutes and seconds
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = '';

  if (hrs > 0) {
    ret += String(hrs) + ':' + (mins < 10 ? '0' : '');
  }

  if (mins > 0) {
    ret += `${mins}${strings.COMMON__MINUTES} ${secs < 10 ? '0' : ''}`;
  }
  ret += String(secs) + strings.COMMON__SECONDS;
  return ret;
}
